import { createContext } from 'react';

const variableContext = createContext();

export default variableContext;